module.exports = __webpack_public_path__ + "img/base_restauration_pizza.8d23e16f.svg";